<template lang="html">
  <div v-if="isValidChunkByID(chunkID)">
    <Chunk :needsVideoTitle="true" :chunkID="chunkID" />
    <hr>
    <Subscribe />
    <hr>
    <h2>Other videos</h2>
    <VideosList :videos="videos" />
  </div>
  <NotFound v-else />
</template>

<script>
import { mapGetters } from 'vuex'
import Chunk from '@/components/Chunk'
import VideosList from '@/components/VideosList'
import Subscribe from '@/components/Subscribe'
import NotFound from '@/views/NotFound'

export default {
  components: {
    Chunk,
    VideosList,
    NotFound,
    Subscribe
  },
  computed: {
    ...mapGetters([
      'chunkByID',
      'videosExceptThis',
      'isValidChunkByID'
    ]),
    chunkID() {
      return this.$route.params.id
    },
    chunk() {
      return this.chunkByID(this.chunkID)
    },
    videos() {
      return this.videosExceptThis(this.chunk.video)
    }
  },
  // Navigation Guards
  // The navigation guards are meant to be triggered only on the view components.
  // https://github.com/vuejs/vue-router/issues/1782
  // watch: {
  //   '$route' (to, from) {
  //     console.log("route changed", from.params.id, ">", to.params.id);
  //     console.log(this.chunkComputed.id);
  // },
  // beforeRouteUpdate(to, from, next) {
  //   console.log(":: beforeRouteUpdate");
  //   next()
  // },
  // beforeRouteLeave (to, from, next) {
  //   console.log(":: route gonna change");
  // },
}
</script>

<style lang="css" scoped>
.root > div {
  margin-bottom: 1rem;
}
</style>
